import { render, staticRenderFns } from "./modal-reassign-activity.component.vue?vue&type=template&id=1d63a321&scoped=true&"
import script from "./modal-reassign-activity.component.vue?vue&type=script&lang=ts&"
export * from "./modal-reassign-activity.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d63a321",
  null
  
)

export default component.exports